import IngredientUpdate from './IngredientUpdate'
export {IngredientUpdate}
export default IngredientUpdate
